import i18next from "../../../../i18n";
import { ServiceGap } from "../../serviceDetail";

type ServiceStepStatusProps = {
  /** The first thing a service lacks, or null when every service is complete. */
  gap: ServiceGap | null;
  /** The whole step is complete — services and everything else on it. */
  complete: boolean;
};

/**
 * Beside the step's Next button while services are being described (SCRUM-114, v2 in SCRUM-117):
 * the first thing missing, or "ready" in green once the step can go on.
 */
const ServiceStepStatus = ({ gap, complete }: ServiceStepStatusProps) => {
  const ready = !gap && complete;
  const message = gap
    ? `serviceDetail.gap.${gap}`
    : ready
      ? "serviceDetail.stepReady"
      : "serviceDetail.stepIncomplete";
  return (
    <p
      className={`order-service-status${ready ? " order-service-status--ok" : ""}`}
      role="status"
    >
      {i18next.t(message)}
    </p>
  );
};

export default ServiceStepStatus;
